module.exports = __webpack_public_path__ + "img/nz.c8360737.svg";